import React from 'react';
import {getElementFromLocalStorage} from 'app/helpers/webStorageUtility';
import {windowIsDefined} from 'app/helpers/windowIsDefined';

const validateAuthStateLocalToken = () => {
  let hasValidLocalToken = false;
  const localToken = windowIsDefined ? getElementFromLocalStorage('pwa-token') : null;

  if (localToken) {
    const tokenParts = localToken.split('.');
    const tokenPayload = tokenParts[1];
    let token = null;
    if (tokenPayload) {
      try {
        token = JSON.parse(window.atob(tokenPayload));
      } catch (e) {}
    }
    if (token) {
      const currentTime = new Date().getTime();
      const tokenExp = token.exp * 1000;
      const validTokenInSec = (tokenExp - currentTime) / 1000;
      hasValidLocalToken = validTokenInSec > 5;
    }
  }
  return {hasValidLocalToken, token: hasValidLocalToken ? localToken : null};
};

export {validateAuthStateLocalToken};
